<template>
  <!-- «?» next to a hard place: one line on hover, the section of the help on click. The span is
       the root: a class given to the component (ml-2) lands on it, not on the tooltip overlay -->
  <span class="help-hint-wrap">
    <v-tooltip :text="text" location="top" max-width="320">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          icon="mdi-help-circle-outline"
          variant="text"
          density="compact"
          size="small"
          color="primary"
          class="help-hint"
          :aria-label="`Справка: ${text}`"
          @click.stop="open"
        ></v-btn>
      </template>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  name: 'HelpHint',
  props: {
    section: { type: String, required: true },
    anchor: { type: String, default: '' },
    text: { type: String, required: true },
    // in a new tab: a dialog or a form being filled stays open
    newTab: { type: Boolean, default: true }
  },
  methods: {
    open() {
      const path = `/help/${this.section}${this.anchor ? '#' + this.anchor : ''}`
      if (this.newTab) window.open(this.$router.resolve(path).href, '_blank')
      else this.$router.push(path)
    }
  }
}
</script>

<style scoped>
/* in the colour of the interface and fully visible: a grey half-transparent «?» was not noticed
   (29.10.2026) */
.help-hint-wrap {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.help-hint :deep(.v-icon) {
  font-size: 22px;
}
</style>
